import { I18n } from 'aws-amplify';
import {buildPublicKnowledgeUrl, getPublicKnowledgeListForChatBot } from '../publicKnowledge/handler/PublicKnowledgeListHandler';
import { memo, useEffect, useState } from "react";
import Constant from "@/common/constant/Constant";
import './ListTicketChatMessage.css';
import Utils from '@/common/utils/utils';
import LoadingMessage from './LoadingMessage'
import { buildConfirmIssuesResolvedMessage,buildFreeMessage,buildQAFormLiveChat,buildQAFormMessage,buildTheEndMessage,postMessage } from './handler/ChatBoxHandler';
import { cloneDeep } from 'lodash';
import { useRecoilValue } from 'recoil';
import { updatePreviewSettingAtom } from '@/state/atom/chatBotPreview';
import { v4 as uuidv4} from 'uuid';
import { createKibanaSelectKnowledgeTicket } from '@/component/system/logKibanaHandler/LogKibanaHandler';
// import localStorageUtil from '@/common/utils/localStorageUtil';
import DisplayOptionBySetting from './DisplayOptionBySetting';
import { getOptionDisplayLength } from './handler/ChatBoxHandler';

function ListTicketMessage({
    message,
    subDomain,
    projectId,
    chatbotSettings,
    messages,
    setMessages,
    supportThreadIdState,
    affiliationOrganization,
    scrollIntoViewMsg,
    isModePreview,
    projectAlias,
    categoryIdSelected,
    formQASystem,
    isMaximizedPanel,
    API,
    projectInuseDetail,
    currentCorporationDetail,
    setIsEnableBtnSend,
    listTagFieldOfSelectedCategory,
    usingAI,
    listCategories
}) {
    const getCategorySettingData = () => {
        let categoryViewStructure = Constant.DEFAULT_VIEW_STRUCTURE;
        let categoryViewId = '';

        const categoryDetail = listCategories.find(category => {
            return category.id === categoryIdSelected;
        });

        if (categoryDetail?.viewStructure) {
            categoryViewStructure = Utils.convertJSONDataToObject(categoryDetail?.viewStructure);
        }

        if (categoryDetail.chatBotCategorySetting) {
            let chatBotCategorySettingObject = Utils.convertJSONDataToObject(categoryDetail.chatBotCategorySetting);
            if (chatBotCategorySettingObject.viewId) {
                categoryViewId = chatBotCategorySettingObject.viewId;
            }
        }

        return { categoryViewStructure, categoryViewId };
    }
    const [messageState, setMessagesState] = useState(message)
    useEffect(() =>{
        if (message.idMessage !== messageState.idMessage) {
            setMessagesState(message)
        }
    }, [message])

    let tagFieldQuery = messageState?.filter;
    let searchData = Utils.convertJSONDataToObject(messageState.searchData);
    const [isLoading, setIsLoading] = useState(true);

    const previewSetting = useRecoilValue(updatePreviewSettingAtom);
    const [freeMessageContent, setFreeMessageContent] = useState(isModePreview ? previewSetting.freeMsg : chatbotSettings.freeMsg);
    const [maxNumberAnswer,setMaxNumberAnswer] = useState(0);

    useEffect(() => {
        if (!isModePreview) {
            setFreeMessageContent(chatbotSettings.freeMsg);
            setMaxNumberAnswer(chatbotSettings.maxNumberAnswer);
        }
    }, [chatbotSettings]);

    useEffect(() => {
        if (isModePreview) {
            if (previewSetting.freeMsg !== freeMessageContent) {
                setFreeMessageContent(previewSetting.freeMsg);
            }

            if (previewSetting.maxNumberAnswer !== maxNumberAnswer) {
                setMaxNumberAnswer(previewSetting.maxNumberAnswer);
            }
        }
    }, [previewSetting]);

    const url =`${window.location.origin}/${subDomain}/${projectAlias}/kb`;
    useEffect(() => {
        let lastMessage = messages[messages.length - 1];
        if (
            lastMessage.idMessage === messageState.idMessage &&
            lastMessage.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TICKET
        ) {
            let maxNumberAnswers = isModePreview ? previewSetting.maxNumberAnswer : chatbotSettings.maxNumberAnswer;
            setIsLoading(true);

            const categoryDetail = listCategories.find(category => {
                return category.id === categoryIdSelected;
            });

            const viewStructure = categoryDetail?.viewStructure;

            getPublicKnowledgeListForChatBot(
                API,
                affiliationOrganization,
                projectId,
                tagFieldQuery,
                1,
                false,
                maxNumberAnswers,
                viewStructure
            ).then( async result => {
                let payload = Utils.convertJSONDataToObject(result.payload);
                let ticketListData = [];
                let listMessageClone = cloneDeep(messages);
                if (payload?.length !== 0) {
                    payload?.forEach(ticketData => {
                        if (!Utils.isEmptyObject(ticketData)) {
                            ticketListData.push({
                                id: Object.keys(ticketData)[0],
                                title: Utils.getTitle(Object.values(ticketData)[0])
                            });
                        }
                    });
                    ticketListData = Utils.isEmptyArray(ticketListData) ? [] : ticketListData;

                    lastMessage.content = cloneDeep(ticketListData);
                    listMessageClone[messages.length - 1] = lastMessage;

                    const newMessage = buildConfirmIssuesResolvedMessage(categoryIdSelected, formQASystem, null, usingAI);
                    if(!isModePreview){
                        postMessage(lastMessage, supportThreadIdState, affiliationOrganization,false);
                        postMessage(newMessage, supportThreadIdState, affiliationOrganization,false);
                    }
                    setMessages([...listMessageClone, newMessage]);
                    setIsLoading(false);
                    scrollIntoViewMsg();
                } else {
                    if(isModePreview) {
                        const freeMessage = buildFreeMessage(previewSetting.freeMsg, 0);
                        listMessageClone[messages.length - 1] = freeMessage;
                        const theEndMessage = buildTheEndMessage(1, formQASystem);
                        if(!isModePreview){
                            postMessage(freeMessage, supportThreadIdState, affiliationOrganization,false,isModePreview);
                            postMessage(theEndMessage, supportThreadIdState, affiliationOrganization,false,isModePreview);
                        }
                        setMessages([...listMessageClone, theEndMessage]);
                    } else {
                        switch(chatbotSettings?.actionWhenNotResolve) {
                            case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_CHAT_WITH_AGENT:
                                let idQALivechat = `qaform_${uuidv4()}`
                                let dataLiveChat = {
                                    isDefault: false,
                                    idQA: idQALivechat,
                                    categoryIdSelected: categoryIdSelected,
                                    formQASystem: formQASystem
                                };
                                const newMessages = buildQAFormLiveChat(dataLiveChat);
                                if(!isModePreview){
                                    postMessage(newMessages, supportThreadIdState, affiliationOrganization,false,isModePreview, idQALivechat);
                                }
                                setMessages([...listMessageClone, newMessages]);
                                break;
                
                            case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_FINISH:
                                let idQA = `qaform_${uuidv4()}`
                                let data = {
                                    isDefault: false,
                                    idQA: idQA,
                                    data: {
                                        categoryIdSelected: categoryIdSelected,
                                        formQASystem: formQASystem
                                    }
                                };
                                const newMessage = buildQAFormMessage(data);
                                if(!isModePreview){
                                    postMessage(newMessage, supportThreadIdState, affiliationOrganization,false,isModePreview, idQA);
                                }
                                setMessages([...listMessageClone, newMessage]);
                                break;
            
                            case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE:
                            default:
                                const freeMessage = buildFreeMessage(freeMessageContent, 0);
                                listMessageClone[messages.length - 1] = freeMessage;
                                const theEndMessage = buildTheEndMessage(1, formQASystem);
                                if(!isModePreview){
                                    postMessage(freeMessage, supportThreadIdState, affiliationOrganization,false,isModePreview);
                                    postMessage(theEndMessage, supportThreadIdState, affiliationOrganization,false,isModePreview);
                                }
                                setMessages([...listMessageClone, theEndMessage]);
                                break;
                        }
                    }
                    
                    setIsLoading(false);
                    scrollIntoViewMsg();
                }
            });
        }else{
            setIsLoading(false)
        }
    }, [messages]);

    const onClickTicketDetail = (id) => {
        let href = encodeURI(`${url}/${id}?origin=chatbot`);
        window.open(href, '_blank', 'noopener,noreferrer'); 
        if(!isModePreview) {
            createKibanaSelectKnowledgeTicket( API, projectInuseDetail, currentCorporationDetail, id)
            // localStorageUtil.setKnowledgeIdViewFromRobo(id);
        }
    }

    const onClickListTicket = () => {
        // let href = `${url}`;
        let newSearchData = !Utils.isEmptyArray(searchData) ? [...searchData] : [];
        // if (Utils.isEmptyArray(newSearchData) && !Utils.isEmptyArray(listTagFieldOfSelectedCategory)) {
        //     newSearchData =  convertTagFieldQuerytoArrayCondition()
        // }

        let { categoryViewStructure: newViewStructure, categoryViewId } = getCategorySettingData();
        let sortParams = newViewStructure?.options?.sort ? newViewStructure?.options?.sort : '';
        
        if(!Utils.isEmptyArray(newSearchData)){
            newViewStructure.tagFields = Utils.getUniqueObjectListInArray([...newViewStructure.tagFields, ...newSearchData]);
        }

        let pageParams = {
            viewStructure: newViewStructure,
            selectedView: categoryViewId ? categoryViewId :'',
            currentPage: 1,
            sortParams: sortParams,
            sortType: ''
        }

        let viewTicketListUrl = buildPublicKnowledgeUrl(subDomain, projectAlias, pageParams, [], Constant.CHATBOT_ORIGIN.CHATBOT)
        // href = viewTicketListUrl;
        window.open(`${window.location.origin}/${viewTicketListUrl}`, '_blank', 'noopener,noreferrer');
    }

    // const convertTagFieldQuerytoArrayCondition = () => {
    //     let arrCondition = [];
    //     if (!Utils.isEmptyArray(listTagFieldOfSelectedCategory)) {
    //         listTagFieldOfSelectedCategory.forEach(tag => {
    //             let tagFieldId = tag.id;
    //             let listItem = tag.child;
    //             if (listItem && !Utils.isEmptyArray(listItem)) {
    //                 listItem?.forEach(item => {
    //                     let tagItemId = item.id;
    //                     let objCondition = {};
    //                     objCondition[tagFieldId] = tagItemId;

    //                     arrCondition.push(objCondition);
    //                 });
    //             }
    //         })
    //     }

    //     arrCondition = [...new Set(arrCondition)];

    //     return arrCondition;
    // }

    useEffect(() => {
        setIsEnableBtnSend(!isLoading);
    }, [isLoading]);

    const renderListTicket = content => {
        if (content.length === 0) return 'not ticket';
        let contentSorted = [];
        if (maxNumberAnswer <= content.length) {
            let listTicketTitle = content.slice(0, maxNumberAnswer);
            contentSorted = Utils.sortListByTitle(listTicketTitle);
        } else {
            contentSorted = Utils.sortListByTitle(content);
        }
        Utils.sortListByTitle(content)
        let isShowSeeMore = maxNumberAnswer < content.length;
        return (
            <>
                <div className="text-question">
                    {I18n.get(messageState?.usingAI ? 'CBOTMSG004-AI-ON' : 'CBOTMSG004').replace('{{totalKnowledge}}', content.length)}
                </div>
                {contentSorted?.map((option,index) => (
                    <div key={`${messageState.idMessage}${index}`}>
                        <DisplayOptionBySetting 
                            key={`${messageState.idMessage}-displaytext`}
                            label={option.title}
                            optionDisplayLength={getOptionDisplayLength(chatbotSettings, previewSetting)}
                            onClickHandler={e => onClickTicketDetail(option.id)}
                            isMaximizedPanel={isMaximizedPanel}
                        />
                    </div>
                ))}
                <div className="btn-seeall-knowledge" onClick={e => onClickListTicket()}>
                   {isShowSeeMore && <span className="text-btn-seeall">すべて見る→</span>}
                </div>
            </>
        );
    };
    
    return (
        <div className={isMaximizedPanel ? 'message-text  maximized-form-text' : 'message-text'}>
            {isLoading ? <LoadingMessage /> : renderListTicket(messageState.content)}
        </div>
    );
}

export default memo(ListTicketMessage);